export enum ComponentState {
  View,
  Edit,
  Error,
  ApproveChanges,
}
